module.exports = __webpack_public_path__ + "media/application/images/guides-widget-bg-cde5b0b2dc4d2ec6af7eaca7826de44b.png";